module.exports = __webpack_public_path__ + "static/media/websiteUnderConstruction.c3e45fc5.png";